import { api } from '../lib/axios';

interface WebConfigurationClient {
  maxValuePrice: number;
  maxValueKm: number;
}

type WebmobileConfigurationClient = WebConfigurationClient;

export interface ConfigurationClient {
  webmobile?: WebmobileConfigurationClient;
  web?: WebConfigurationClient;
}

export function getConfigurationsClient(): Promise<ConfigurationClient> {
  return api.get<ConfigurationClient>('configuration-clients');
}
